/**
 *
 * PimsLogo index file.
 *
 */

import PimsLogo from "./PimsLogo";

export default PimsLogo;
